/* global axios */
import ApiClient from '../ApiClient';

class AiAgentKnowledgeSourcesAPI extends ApiClient {
  constructor() {
    super('ai_agents', { accountScoped: true });
  }

  index(agentId) {
    return axios.get(`${this.url}/${agentId}/knowledge_sources`);
  }

  toggle(agentId, sourceId, isEnabled) {
    return axios.patch(`${this.url}/${agentId}/knowledge_sources/${sourceId}`, {
      knowledge_source: { is_enabled: isEnabled },
    });
  }
}

export default new AiAgentKnowledgeSourcesAPI();
